import React, { useEffect, useState } from 'react';
import VersionModalStyle from './style';
import icons from 'src/assets/icon';
import { Flex, Table } from 'antd';
import { MinusSquareOutlined, PlusSquareOutlined } from '@ant-design/icons';
import useQueryApi from 'src/hooks/useApiQuery';
import { getAllVersion } from 'src/api/apiGetAllVersion';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { DATE_FORMAT } from 'src/const/common';
interface VersionModalProps {
    idQuote?: any;
}

const VersionModal: React.FC<VersionModalProps> = ({ idQuote }) => {
    const location = useLocation();
    const containsRevisionHistory =
        location.pathname.includes('revisionHistory');

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 6,
    });

    const { data, refetch, isLoading } = useQueryApi(
        ['idQuote', idQuote],
        () => getAllVersion(idQuote),
        {
            enabled: !!idQuote,
        },
    );

    useEffect(() => {
        if (idQuote) {
            refetch();
        }
    }, [idQuote, refetch]);

    const dataVersion = (data as { versions: any })?.versions || [];
    const hasExpandableRow = dataVersion.some(
        (item: any) => item?.quotes?.length > 0,
    );

    const handleRowClick = (id: string, isMultiple: boolean = false) => {
        window.open(
            `/${
                isMultiple ? 'multipleQuotes' : 'quoteDetail'
            }/introduction?id=${id}`,
            '_blank',
        );
    };

    const handleTableChange = (pagination: any) => {
        setPagination({
            pageSize: pagination.pageSize,
            current: pagination.current,
        });
    };
    const columns = [
        {
            title: 'Quote Title',
            dataIndex: 'title',
            key: 'title',
            className: 'quoteTitleColumn',
            width: '445px',
        },
        {
            title: 'Departure Date',
            dataIndex: 'departureDate',
            key: 'departureDate',
            className: 'departureDateColumn',
            render: (text: string) => {
                return <>{text && moment(text).utc().format('D MMM YYYY')}</>;
            },
        },
        {
            title: 'Version',
            dataIndex: 'version',
            key: 'version',
        },
        {
            title: 'Version detail',
            dataIndex: 'details',
            key: 'details',
            className: 'vertionDetailColumn',
        },
        {
            title: 'Version Status',
            dataIndex: 'status',
            key: 'status',
            className: 'captionColumn',
            render: (text: string, record: any) => {
                const updateDate = record?.date;
                return (
                    <>
                        <div>{record?.status}</div>
                        {updateDate && (
                            <div className="white-space">
                                {moment(updateDate)
                                    .utc()
                                    .local()
                                    .format(`${DATE_FORMAT} HH:mm`)}
                            </div>
                        )}
                    </>
                );
            },
        },
        {
            title: 'Opened',
            dataIndex: 'openedDate',
            key: 'openedDate',
            className: 'captionColumn',
            render: (text: string) => {
                return (
                    <div className="white-space">
                        {text &&
                            moment(text)
                                .utc()
                                .local()
                                .format(`${DATE_FORMAT} HH:mm`)}
                    </div>
                );
            },
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            render: (text: string, record: any) => {
                const { id: idVersion, multipleVersionId } = record;
                return (
                    <div className="viewGroupsActions">
                        {multipleVersionId && (
                            <img
                                alt=""
                                className="actionIcon"
                                src={icons.rectangle}
                                onClick={() =>
                                    handleRowClick(multipleVersionId, true)
                                }
                            />
                        )}

                        <img
                            alt=""
                            className="actionIcon"
                            src={icons.eyeIcon}
                            onClick={() => handleRowClick(idVersion)}
                        />
                    </div>
                );
            },
        },
    ];
    return (
        <VersionModalStyle>
            {containsRevisionHistory && (
                <div className="revisionId">{idQuote}</div>
            )}
            <Table
                dataSource={dataVersion}
                columns={columns}
                pagination={pagination}
                rowKey={(record) => record?.multipleVersionId || record?.id}
                loading={isLoading}
                onChange={handleTableChange}
                size="small"
                {...(hasExpandableRow && {
                    expandable: {
                        columnWidth: 28,
                        expandIcon: ({
                            expanded,
                            expandable,
                            record,
                            onExpand,
                        }) => {
                            if (!expandable) return null;
                            const Icon = expanded
                                ? MinusSquareOutlined
                                : PlusSquareOutlined;
                            return (
                                <button
                                    type="button"
                                    className="expand-icon"
                                    aria-label={
                                        expanded ? 'Collapse row' : 'Expand row'
                                    }
                                    aria-expanded={expanded}
                                    onClick={(event) => onExpand(record, event)}
                                >
                                    <Icon />
                                </button>
                            );
                        },
                        expandedRowRender: (record) => {
                            const { quotes = [] } = record;
                            return (
                                <>
                                    {quotes.map((quotes: any) => (
                                        <Flex
                                            key={quotes?.id}
                                            gap={8}
                                            align="flex-start"
                                            className="item-quote"
                                        >
                                            <div className="name">
                                                {quotes?.id}
                                            </div>
                                            <div>{quotes?.title}</div>
                                        </Flex>
                                    ))}
                                </>
                            );
                        },
                        rowExpandable: (record) => record?.quotes?.length > 0,
                    },
                })}
            />
        </VersionModalStyle>
    );
};

export default VersionModal;
